interface LogoProps {
	className?: string
}

// NOTE: the wordmark, with the registered mark set as a superscript
const Logo = ({ className = 'text-[22px]' }: LogoProps) => {
	return (
		<span className={`font-semibold tracking-[-0.02em] ${className}`}>
			helfy<span className="align-super text-[0.55em]">®</span>
		</span>
	)
}

export default Logo
